export const NO_DATA = 'NO_DATA'
export const TOO_LARGE = 'TOO_LARGE'
export const UPLOAD_ERROR = 'UPLOAD_ERROR'
